import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const PackageFilters = ({ filters, onFiltersChange, countries = [] }) => {
  const tierOptions = [
    { value: 'all', label: 'Tous les niveaux' },
    { value: 'bronze', label: 'Bronze' },
    { value: 'silver', label: 'Silver' },
    { value: 'gold', label: 'Gold' }
  ];

  const statusOptions = [
    { value: 'all', label: 'Tous les statuts' },
    { value: 'active', label: 'Actif' },
    { value: 'inactive', label: 'Inactif' }
  ];

  const countryOptions = [
    { value: 'all', label: 'Tous les pays' },
    ...countries?.map(country => ({
      value: country?.id,
      label: `${country?.countryName} (${country?.countryCode})`
    }))
  ];

  return (
    <div className="bg-card rounded-lg p-4 border border-border shadow-card mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="relative">
          <Icon 
            name="Search" 
            size={18} 
            className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none" 
          />
          <Input
            type="text"
            placeholder="Rechercher un pack..."
            value={filters?.search}
            onChange={(e) => onFiltersChange({ ...filters, search: e?.target?.value })}
            className="pl-10"
          />
        </div>

        <Select
          options={countryOptions}
          value={filters?.countryId || 'all'}
          onChange={(value) => onFiltersChange({ ...filters, countryId: value })}
          placeholder="Pays"
        />

        <Select
          options={tierOptions}
          value={filters?.tier}
          onChange={(value) => onFiltersChange({ ...filters, tier: value })}
          placeholder="Niveau"
        />

        <Select
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFiltersChange({ ...filters, status: value })}
          placeholder="Statut"
        />
      </div>
    </div>
  );
};

export default PackageFilters;